import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../css-coding/navbar.css';
import Logo from '../assets/Logo.png';
import brand from '../assets/brandname.png';
import Popup from "./popup.jsx"; // ✅ your popup

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [coursesOpen, setCoursesOpen] = useState(false); // ✅ popup state

  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '#', label: 'Courses', type: 'popup' }, // ✅ popup type
    { path: '/services', label: 'Services' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/blog', label: 'Blog' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: 'https://itsprakashhere.framer.website/', label: 'Contact' },
  ];

  const scrollToTop = (options = { immediate: true }) => {
    const l = (typeof window !== 'undefined' && window.lenis) || null;

    if (l && typeof l.scrollTo === 'function') {
      try {
        l.scrollTo(0, { immediate: options.immediate });
      } catch {
        l.scrollTo(0);
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1180);
      if (window.innerWidth > 768) {
        setMenuOpen(false);
        document.body.style.overflow = 'auto';
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.style.overflow = !menuOpen ? 'hidden' : 'auto';
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    document.body.style.overflow = 'auto';
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav className={`navbar ${menuOpen ? 'menu-open' : ''}`}>
        <div className="navbar-logo">
          <img src={Logo} alt="Logo" />
          <div className="brandname">
            <img src={brand} alt="Logo" />
          </div>
        </div>

        {!isMobile && (
          <>
            <ul className="navbar-links">
              {navItems.map((item) => (
                <li key={item.label}>
                  {item.type === 'popup' ? (
                    // ✅ POPUP BUTTON (Desktop)
                    <button
                      className="nav-popup-btn"
                      onClick={() => setCoursesOpen(true)}
                    >
                      {item.label}
                    </button>
                  ) : item.path.startsWith('https://') ? (
                    <a href={item.path} target="_blank" rel="noopener noreferrer">
                      {item.label}
                    </a>
                  ) : (
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => (isActive ? 'active' : '')}
                      end={item.path === '/'}
                      onClick={() => scrollToTop({ immediate: true })}
                    >
                      {item.label}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>

            <div className="navbar-button">
              <a href="https://cal.com/itsprakashhere/30min" target="_blank" rel="noopener noreferrer">
                <button type="button">Book a Call</button>
              </a>
            </div>
          </>
        )}

        {isMobile && (
          <button
            className="menu-toggle"
            onClick={handleToggleMenu}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            <span className={`hamburger ${menuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
            </span>
          </button>
        )}
      </nav>

      {/* ---------------- MOBILE MENU ---------------- */}

      {isMobile && menuOpen && (
        <div className="mobile-menu" onClick={handleCloseMenu}>
          <div className="mobile-menu-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCloseMenu}>
              ✕
            </button>
            <nav className="mobile-nav">
              <ul>
                {navItems.map((item, index) => (
                  <li key={item.label} style={{ animationDelay: `${index * 0.1}s` }}>
                    {item.type === 'popup' ? (
  <NavLink
    to="#"
    end
    className={() => ""}
    onClick={(e) => {
      e.preventDefault();
      handleCloseMenu();
      setCoursesOpen(true);
    }}
  >
    {item.label}
  </NavLink>
) : item.path.startsWith('https://') ? (
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleCloseMenu}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <NavLink
                        to={item.path}
                        onClick={() => {
                          handleCloseMenu();
                          scrollToTop({ immediate: true });
                        }}
                        className={({ isActive }) => (isActive ? 'active' : '')}
                        end={item.path === '/'}
                      >
                        {item.label}
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* ---------------- POPUP COMPONENT ---------------- */}
      <Popup
        isOpen={coursesOpen}
        onClose={() => setCoursesOpen(false)}
      />
    </>
  );
};

export default Navbar;

